import type { Ref } from "react";

import { componentManager, rwc } from "@frontend/bridge/ComponentManager";

import { TimesheetExport, type TimesheetExportHandle } from "./TimesheetExport";
import {
  type TimesheetExportDataProps,
  timesheetExportDataSchema,
} from "./TimesheetExport.schema";

declare module "@frontend/bridge/types" {
  interface ComponentRegistryMap {
    "timesheet-export": {
      props: TimesheetExportDataProps;
      handle: TimesheetExportHandle;
    };
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "rwc-timesheet-export": HTMLElement & TimesheetExportHandle;
  }
}

export function RWCTimesheetExport({
  ref,
}: TimesheetExportDataProps & { ref?: Ref<TimesheetExportHandle> }) {
  return <TimesheetExport ref={ref} />;
}

componentManager.register(
  rwc("timesheet-export", {
    component: RWCTimesheetExport,
    dataSchema: timesheetExportDataSchema,
  }),
);
